import { ClientRegisterForm } from "../types/forms/client-register-form";
import { UserForm } from "../types/forms/user-form";

export class UserService {
  constructor(private readonly apiUrl: string) {}

  async me() {
    try {
      const resultat = await fetch(`${this.apiUrl}/api/users/me`, {
        method: "GET",
        cache: "no-store",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!resultat.ok) {
        throw new Error(`Erreur HTTP: ${resultat.status}`);
      }

      return await resultat.json();
    } catch (error) {
      console.error("Erreur lors de la récupération de l'utilisateur:", error);
      throw error;
    }
  }

  async update(userId: number, userData: UserForm) {
    try {
      const resultat = await fetch(`${this.apiUrl}/api/clients/${userId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(userData),
      });

      if (!resultat.ok) {
        throw new Error(`Erreur HTTP: ${resultat.status}`);
      }
    } catch (error) {
      console.error("Erreur lors de la mise à jour du client:", error);
      throw error;
    }
  }

  async register(userData: ClientRegisterForm) {
    try {
      const resultat = await fetch(`${this.apiUrl}/api/register/client`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(userData),
      });

      if (!resultat.ok) {
        throw new Error(`Erreur HTTP: ${resultat.status}`);
      }
    } catch (error) {
      console.error("Erreur lors de la création du compte du client:", error);
      throw error;
    }
  }
}
